/** @format */
import React, {
    Context,
    PropsWithChildren,
    createContext,
    useMemo,
} from 'react';

import { FeatureFlag } from '@toucan/common/services/feature-flags/types';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type FeatureFlags = FeatureFlag[] | undefined;

type FeatureFlagContextProps = {
    featureFlags: FeatureFlags;
};

type FeatureFlagProviderProps = PropsWithChildren<{
    featureFlags: FeatureFlags;
}>;

export const FeatureFlagContext: Context<FeatureFlagContextProps> =
    createContext<FeatureFlagContextProps>({
        featureFlags: [],
    });

export const FeatureFlagProvider = ({
    featureFlags,
    children,
}: FeatureFlagProviderProps) => {
    const value = useMemo(
        () => ({
            featureFlags,
        }),
        [featureFlags]
    );

    return (
        <FeatureFlagContext.Provider value={value}>
            {children}
        </FeatureFlagContext.Provider>
    );
};
